export default "__VITE_ASSET__BbjNganC__"